<dgx-modal
  [canCancel]="false"
  [isHeaderBorderless]="true"
  [isPendingWithOverlay]="true"
  [useDefaultForm]="false"
  [useDefaultSubmitButton]="false"
>
  <ng-container class="modal-body">
    <div class="guts-p-h-2">
      <div class="l_flex alert__dialog">
        <df-icon
          icon="checkmark-badge"
          size="large"
          class="center-item color-ebony-a61 giga"
        ></df-icon>
      </div>
      <div class="center-text font-semibold zeta">
        {{ i18n.bulkUpdateModal_NotAppearRightAway }}
      </div>
      <div class="center-text font-medium zeta guts-p-v-2">
        {{ i18n.bulkUpdateModal_WillSendEmail }}
      </div>
    </div>
  </ng-container>
  <ng-container class="modal-footer">
    <button
      type="submit"
      df-button
      dfButtonType="primary"
      (click)="done()"
      data-dgat="orgBulkUploadSuccess-135"
    >
      <span>{{ i18n.Core_Done }}</span>
    </button>
  </ng-container>
</dgx-modal>
